import { transformCurrencyAmountDto } from './currency-amount';
export const transformClosetPromotionOrder = dto => {
  var _dto$tax_coverage_ava, _dto$tax_covered;

  return {
    id: dto.id,
    total: transformCurrencyAmountDto(dto.total),
    payable: transformCurrencyAmountDto(dto.payable),
    effectiveDays: dto.effective_days,
    discount: transformCurrencyAmountDto(dto.discount),
    discountPercentage: dto.discount_percentage,
    salesTax: dto.sales_tax ? transformCurrencyAmountDto(dto.sales_tax) : null,
    isTaxCoverageAvailable: (_dto$tax_coverage_ava = dto.tax_coverage_available) !== null && _dto$tax_coverage_ava !== void 0 ? _dto$tax_coverage_ava : null,
    isTaxCovered: (_dto$tax_covered = dto.tax_covered) !== null && _dto$tax_covered !== void 0 ? _dto$tax_covered : null
  };
};
export const transformClosetPromotionMotivation = dto => ({
  text: dto.text,
  highlight: dto.highlight
});
export const transformClosetPromotion = dto => ({
  closetPromotionOrder: transformClosetPromotionOrder(dto.closet_promotion_order),
  motivation: dto.motivation ? transformClosetPromotionMotivation(dto.motivation) : undefined
});
export const transformClosetPromotionPricing = dto => ({
  effectiveDays: dto.effective_days,
  isSalesTaxApplicable: dto.sales_tax_applicable,
  totalPrice: transformCurrencyAmountDto(dto.total_price),
  pricePerDay: transformCurrencyAmountDto(dto.price_per_day),
  discountedPrice: transformCurrencyAmountDto(dto.discounted_price)
});